import { nsTerminal } from '@/app/i18n/namespaces';

const NETWORK_INTERFACE_TYPE = {
    ETHERNET: { name: 'ETHERNET', entity: 'network_interface_type.ETHERNET', namespace: nsTerminal },
    GPRS: { name: 'GPRS', entity: 'network_interface_type.GPRS', namespace: nsTerminal },
    WIFI: { name: 'WIFI', entity: 'network_interface_type.WIFI', namespace: nsTerminal },
    PPP: { name: 'PPP', entity: 'network_interface_type.PPP', namespace: nsTerminal },
    PAYLUDD: { name: 'PAYLUDD', entity: 'network_interface_type.PAYLUDD', namespace: nsTerminal },
    OTHER: { name: 'OTHER', entity: 'network_interface_type.OTHER', namespace: nsTerminal },
    NOT_SPECIFIED: { name: 'NOT_SPECIFIED', entity: 'network_interface_type.NOT_SPECIFIED', namespace: nsTerminal }
};

export default NETWORK_INTERFACE_TYPE;